/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-runloop */
import Service from '@ember/service';
import { cancel, later } from '@ember/runloop';
import { tracked } from '@glimmer/tracking';

export default class CountdownButtonService extends Service {
  @tracked timerId = '';
  @tracked delayActions = null;

  decrementCountdown() {
    if (this.delayActions.countdown > 0) {
      let timerId = later(
        this,
        () => {
          this.decrementProperty('delayActions.countdown');
          this.decrementCountdown();
        },
        1000,
      );
      this.timerId = timerId;
    } else {
      this.set('delayActions.delay', false);
    }
  }

  // Call on dialogue close to prevent memory leaking
  cleanup() {
    let timerId = this.timerId;
    if (timerId) {
      cancel(timerId);
    }

    this.delayActions = { countdown: 0, delay: false };
  }

  // Sets required args and initiates countdown function
  initialise(countdown) {
    this.delayActions = { countdown, delay: true };
    this.decrementCountdown();
  }
}
